import * as React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { CenterLoader } from "../components/Loaders";
import { LANDING } from "./constants";

const Layout = React.lazy(() => import("../shared/layout/"));

const RouterConfig: React.FC = () => {
  return (
    <React.Fragment>
      <BrowserRouter>
        <React.Suspense fallback={CenterLoader()}>
          <Switch>
            <Route component={Layout} path={LANDING} />
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    </React.Fragment>
  );
};

export { RouterConfig };
